import {Button, Col, Modal, Row} from "react-bootstrap";
import {
  generateValidationSchema,
} from "../../../../utils/AppFunction";
import React, {Dispatch, SetStateAction, useContext, useEffect, useState} from "react";
import {AppContext} from "../../../../appContext/AppContext";
import {XayDungKeHoachContext} from "../HoTroKyThuatChuyenMon";
import {Formik, Form} from "formik";
import {CODE, MAX_PAGE_SIZE, TYPE_WH} from "../../../../utils/Constant";
import {toast} from "react-toastify";
import WfButton from "../../../../workflows/components/WfButton";
import {IconButtonSave} from "../../../../component/IconSvg";
import {formatDateDTO} from "../../../../utils/FormatUtils";
import {TypeKeHoach} from "../models/KeHoachModel";
import ModelHeader from "../../../../component/ModelHeader";
import DialogBienBanHoTro from "./DialogBienBanHoTro";
import {OctTable} from "@oceantech/oceantech-ui";
import {TYPE_KB_CB} from "../constants/constansKeHoach";
import {searchdsDot} from "../services/services";

interface Props {
  show: boolean;
  onHide: () => void;
  initialValues: any;
  setInitialValues: Dispatch<SetStateAction<any>>
  warehouseId?: any;
  type: TypeKeHoach;
}

const DialogBienBanNhiemVu = (props: Props) => {
  const {show, onHide, setInitialValues, initialValues, type} = props;
  const {setIsLoading} = useContext(AppContext);
  const {dsKeHoach, setDsKeHoach, detailPhieuKeHoach, setDetailPhieuKeHoach} = useContext(XayDungKeHoachContext);
  const [isView, setIsView] = useState<boolean>(false);
  const [listJsonGenerateVT, setListJsonGenerateVT] = useState<any>([]);
  const [initialValuesFormThemVT, setInitialValuesFormThemVT] = useState<any>({});
  const [openDialogThemMoi, setOpenDialogThemMoi] = useState<boolean>(false);
  const [itemSelected, setItemSelected] = useState<any>();
  const [dsItems, setDsItems] = useState<any>([]);

  const handleEdit = (row: any, index: number) => {
    setItemSelected(row);
    setOpenDialogThemMoi(true)
  };

  const handleFormSubmit = async (values: any) => {
    const dataSubmit = {
      slipDto: {
        ...initialValuesFormThemVT,
        type: TYPE_WH.IMPORT,
        doCreation: values?.keHoach?.id ? formatDateDTO(values?.keHoach?.doCreation) : formatDateDTO(new Date()),
        listOfInstructions: [...(dsKeHoach || [])].map(item => {
          return (
            {
              ...item,
              id: item?.id || null,
            }
          )
        })
      },
      trackerCode: type.trackerCode,
      termModelType: type?.formVatTu,
    };
  };

  const getListDsDot = async () => {
    try {
      const data = await searchdsDot(initialValues?.id)
      setDsItems(data?.data?.data)
    } catch (e) {

    }
  }
  useEffect(() => {
    if(initialValues?.id) {
      getListDsDot()
    }
  }, [initialValues?.id]);
  const handleCloseDialog = () => {
    setOpenDialogThemMoi(false);
  };

  // Tạo hàm tạo columns động cho mỗi bảng

  const columns = [
    {
      name: "STT",
      field: "",
      headerStyle: {
        width: 80,
      },
      cellStyle: {
        textAlign: "center",
      },
      render: (row: any, index: number, stt: number) => stt,
    },
    ...(!isView ?
      [
        {
          name: "Thao tác",
          field: "",
          headerStyle: {
            width: 100,
          },
          cellStyle: {
            textAlign: "center",
            justifyContent: "center"
          },
          render: (row: any, index: number, stt: number) =>
            <div className="d-flex justify-content-center">
              <i
                onClick={() => handleEdit(row, index)}
                className="bi bi-pencil-square text-navy cursor-pointer"
                style={{cursor: 'pointer', marginRight: '10px'}}
                title="Sửa"
              ></i>
            </div>
        },
      ] : []),
    {
      name: "Buổi hỗ trợ",
      field: "batchName",
      headerStyle: {
        minWidth: 120,
      },
      cellStyle: {
        textAlign: "center",
      },
      render: (row: any) => row.batchName || row.item?.batchName || '',
    },
    {
      name: "Ngày hỗ trợ",
      field: "startTime",
      headerStyle: {
        minWidth: 200,
      },
      cellStyle: {
        textAlign: "center",
      },
      render: (row: any) => row.startTime || row.item?.startTime || '',
    },
  ];

  return (
    <Modal
      centered
      show={show}
      size="xl"
      fullscreen
      className="page-full spaces h-calc-vh-50 dialog-coso-kb-cb"
    >
      <Formik
        enableReinitialize
        validateOnChange={true}
        validateOnBlur={true}
        initialValues={{keHoach: initialValuesFormThemVT}}
        validationSchema={generateValidationSchema(listJsonGenerateVT, 'keHoach')}
        onSubmit={handleFormSubmit}
      >
        {({values, touched, errors, setValues, handleChange, handleSubmit, setFieldValue}) => (
          <>
            <Form onSubmit={handleSubmit}>
              <ModelHeader onHide={onHide} title={`Biên bản thực hiện nhiệm vụ`}/>
              <Modal.Body className="spaces p-0 bg-white">
                <div className="spaces px-10">
                  <div className="spaces mt-12 border-table custom-table">
                    <div className="d-flex spaces pr-8 mt-6 bg-white justify-content-between align-items-center mb-6">
                      <div className=" bg-white flex align-items-center mr-13 spaces">
                        <div className="title spaces ml-10">
                          Buổi hỗ trợ
                        </div>
                      </div>
                    </div>
                    <OctTable
                      id="table-tt-nhap-thuoc"
                      className={`spaces custom-header-table table-nhan-luc`}
                      columns={columns}
                      data={dsItems}
                      noToolbar
                      clearToolbar
                      noPagination
                      fixedColumnsCount={-1}
                    />


                  </div>
                </div>
              </Modal.Body>
              <div className="bottom-button d-flex justify-content-start w-100 bg-white spaces py-6 pl-5">
                {(values.keHoach?.id || detailPhieuKeHoach?.id) && !detailPhieuKeHoach?.isView && (
                  <WfButton
                    additionalFunc={(data: any) => {
                      setDetailPhieuKeHoach({
                        ...detailPhieuKeHoach,
                        status: data?.currCode,
                        statusCode: data?.currCode,
                        statusId: data?.currId,
                      })
                    }}
                    tracker={type.trackerCode}
                    onHide={onHide}
                    objectId={values.keHoach?.id || detailPhieuKeHoach?.id}
                  />
                )}
                {!isView &&
                    <Button type="submit" className="btn btn-fill min-w-120px spaces mx-3">
                        <IconButtonSave/> Lưu
                    </Button>
                }
              </div>
            </Form>
          </>
        )}
      </Formik>
      {openDialogThemMoi && <DialogBienBanHoTro
          type={TYPE_KB_CB.BIEN_BAN_HO_TRO}
          show={openDialogThemMoi}
          onHide={handleCloseDialog}
          initialValues={itemSelected}
          setInitialValues={setItemSelected}
          getListDsDot={getListDsDot}
      />}
    </Modal>
  );
};

export default DialogBienBanNhiemVu;
